// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <svg
      width="129"
      height="129"
      viewBox="0 0 129 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background (optional) */}
      <rect
        x="0"
        y="0"
        width="129"
        height="129"
        rx="20"
        fill={theme.vars.palette.primary.main}
      />

      {/* Letter D */}
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="90"
        fontWeight="700"
        fill={theme.vars.palette.primary.contrastText}
        fontFamily="Arial, Helvetica, sans-serif"
      >
        D
      </text>
    </svg>
  );
}
